// extracted by mini-css-extract-plugin
module.exports = {"rating-icons":"RatingIcons_rating-icons__BH74m","icon":"RatingIcons_icon__3mcB4","inactive":"RatingIcons_inactive__3nBnS"};